import { InvalidDSGModels } from '@/types/remote-diagnose'

export const DSG_MODELS = [
  'DQ200',
  'DQ250',
  'DQ400',
  'DQ500',
  'DL382',
  'DL501',
  'Multitronic',
  InvalidDSGModels.DSG_UNSURE
]

export const INVALID_DSG_CODES = ['0AM', '02E', '0AW']
